<div *ngIf="!isLoading || globalProducts">
    <div class="d-flex p-align-center mb-3">
        <app-combine-view-switcher class="w-100"
                                   [hideSearch]="hideSearch"
                                   [showAdditionalFilters]="showAdditionalFilters"
                                   [isSortingAvailable]="isDataView && !hideSorting"
                                   (onSort)="onSortChange($event)"
                                   (searchAndLoadData)="onLoadData($event)"
                                   [sortOptions]="sortOptions"></app-combine-view-switcher>
    </div>

    <ng-container *ngIf="isTableView">
        <app-table-view [items]="globalProducts"
                        [total]="total"
                        (openDetails)="openDetails($event)"
                        (onQuickAction)="onClickQuickAction($event)"
                        (searchAndLoadData)="onLoadData($event)">
        </app-table-view>
    </ng-container>
    <ng-container *ngIf="isDataView">
        <app-data-view [items]="globalProducts"
                       [total]="total"
                       [hideSearch]="hideSearch"
                       [isSortingAvailable]="true"
                       [sortOptions]="sortOptions"
                       [sortField]="sortField"
                       [sortOrder]="sortOrder"
                       [hideToolbar]="true"
                       (onQuickAction)="onClickQuickAction($event)"
                       (openDetails)="openDetails($event)"
                       (searchAndLoadData)="onLoadData($event)">
        </app-data-view>
    </ng-container>
</div>

<div class="spinner-container" *ngIf="isLoading || !globalProducts">
    <p-progressSpinner></p-progressSpinner>
</div>
